import { ComponentType } from 'react';
import { CompanySettings, IntegrationSettings, IntegrationProfiles, PlayerAuthSettings, PaymentSettings, StoreLayout, StoreSettings, UsersSettings, EventsSettings } from 'components/Settings';
import { ERouteContext, SettingsConfig } from '../types';
import { ESettingsState } from 'components/Settings/Settings.types';
import PortalSettings from 'views/PortalSettings/PortalSettings/PortalSettings';

const basePaths = [
  ESettingsState.USERS,
  ESettingsState.INTEGRATION,
  ESettingsState.EVENTS
];

export const settingsConfigMap: Record<ERouteContext, SettingsConfig> = {
  [ERouteContext.PROJECT]: {
    defaultTab: ESettingsState.COMPANY,
    paths: [
      ESettingsState.COMPANY,
      ESettingsState.PROFILES,
      ESettingsState.PLAYER_AUTH,
      ESettingsState.PAYMENTS,
      ESettingsState.LAYOUT,
      ESettingsState.STORE_SETTINGS,
      ...basePaths
    ]
  },
  [ERouteContext.PORTAL]: {
    defaultTab: ESettingsState.PORTAL,
    paths: [
      ESettingsState.PORTAL,
      ESettingsState.PLAYER_AUTH,
      ...basePaths
    ]
  },
  [ERouteContext.PORTAL_LEVEL_STORE]: {
    defaultTab: ESettingsState.COMPANY,
    paths: [
      ESettingsState.COMPANY,
      ESettingsState.PAYMENTS,
      ESettingsState.LAYOUT,
      ESettingsState.STORE_SETTINGS,
      ...basePaths
    ]
  }
}; 

export const componentMap: Record<string, ComponentType<any>> = {
  [ESettingsState.COMPANY]: CompanySettings,
  [ESettingsState.PORTAL]: PortalSettings,
  [ESettingsState.USERS]: UsersSettings,
  [ESettingsState.INTEGRATION]: IntegrationSettings,
  [ESettingsState.PROFILES]: IntegrationProfiles,
  [ESettingsState.PLAYER_AUTH]: PlayerAuthSettings,
  [ESettingsState.PAYMENTS]: PaymentSettings,
  [ESettingsState.LAYOUT]: StoreLayout,
  [ESettingsState.STORE_SETTINGS]: StoreSettings,
  [ESettingsState.EVENTS]: EventsSettings
};